import React from 'react';

const { Provider: GenresProvider, Consumer: GenresConsumer } = React.createContext();

export { GenresProvider, GenresConsumer };
